import { Box, Typography } from '@mui/material'
import React from 'react'
import HeaderCountBadge from './HeaderCountBadge'

type HeaderCountLabelProps = {
  label: string
  count: number
  isLoading?: boolean
}

const HeaderCountLabel = ({ label, count, isLoading }: HeaderCountLabelProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', pr: 2 }}>
      <Typography variant="h5" component={'h3'}>
        {`${label}:`}
      </Typography>
      <HeaderCountBadge count={count} isLoading={isLoading} />
    </Box>
  )
}

export default HeaderCountLabel
